export const getDataKey = (location: string, name: string, filters: object) =>
  JSON.stringify({
    location,
    name,
    filters,
  });
